/**
 * 预加载所有图标到离线模式
 * 从 @iconify/json 动态加载所有需要的图标集
 * 解决打包后从 api.iconify.design 加载图标的问题
 */
import { addIcon, addCollection } from "@iconify/vue/offline"

// 动态导入图标集 JSON 数据
import epIconsData from '@iconify/json/json/ep.json'
import riIconsData from '@iconify/json/json/ri.json'
import mdiIconsData from '@iconify/json/json/mdi.json'

// console.log('开始预加载图标集到离线模式...')

// 加载完整的 Element Plus 图标集
addCollection(epIconsData)
// console.log(`✓ EP 图标集已加载: ${Object.keys(epIconsData.icons).length} 个图标`)

// 加载完整的 Remix Icon 图标集
addCollection(riIconsData)
// console.log(`✓ RI 图标集已加载: ${Object.keys(riIconsData.icons).length} 个图标`)

// 加载 Material Design Icons 图标集（包含 Excel 和 Word 图标）
addCollection(mdiIconsData)
// console.log(`✓ MDI 图标集已加载: ${Object.keys(mdiIconsData.icons).length} 个图标`)

// console.log(`✓ 图标预加载完成，总计: ${Object.keys(epIconsData.icons).length + Object.keys(riIconsData.icons).length + Object.keys(mdiIconsData.icons).length} 个图标`)
// console.log('所有 ep:、ri: 和 mdi: 图标现在都可以离线使用')

